// Sentinel UUIDs used by the backend to represent "no selection" or "any"
export const NO_COACH_ID  = "00000000-0000-0000-0000-000000000000"; // "No coach" / "Any boat"
export const ANY_COACH_ID = "00000000-0000-0000-0000-000000000001"; // "Any coach"

export const API_BASE = window.__ENV__?.API_BASE || "https://api.cityswell.com.ua/api";

// TODO: move /contact endpoint to the main API (API_BASE) once the Telegram bot
// backend merges it in, then remove TELEGRAM_BOT_API entirely.
export const TELEGRAM_BOT_API = window.__ENV__?.TELEGRAM_BOT_API || "";
// Note: SENTRY_DSN is consumed directly in index.js, not exported from here.
